import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-[#fafafd] flex flex-col">
      <Header />
      <main className="flex-1 w-full mx-auto bg-[#fafafd] py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="bg-white p-8 rounded-2xl shadow-md border">
            <h1 className="text-4xl md:text-4xl font-bold text-gray-600 mb-6 text-center">
              Privacy Policy
            </h1>
            <p className="text-lg text-gray-600 text-center mb-8">
              Effective Date: December 1, 2024
            </p>

            <section className="mb-8">
              <p className="text-gray-600 mb-4">
                At paralegal.lk, we are committed to protecting your privacy and the security of your personal information. This Privacy Policy outlines how we collect, use, and safeguard your information when you use our legal search engine platform with an annual subscription. By using paralegal.lk, you consent to the practices described in this policy.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">Information We Collect</h2>
              <p className="text-gray-600 mb-4">When you use our platform, we may collect the following information:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li><span className="font-semibold">Personal Information:</span> Name, email address, and phone number provided during registration or subscription.</li>
                <li><span className="font-semibold">Company or organization details</span> if applicable.</li>
                <li><span className="font-semibold">Payment Information:</span> Billing details processed through PayHere, a trusted third-party payment gateway. We do not store your full payment details.</li>
                <li><span className="font-semibold">Authentication Data:</span> WSO2 Asgardeo is used for identity management, ensuring maximum security and compliance with the OIDC standard.</li>
                <li><span className="font-semibold">Technical Information:</span> IP address, browser type, device details, and usage data collected automatically via cookies and similar technologies.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">Use of Information</h2>
              <p className="text-gray-600 mb-4">We use the collected information for the following purposes:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li><span className="font-semibold">Account Management:</span> To create, manage, and authenticate user accounts securely.</li>
                <li><span className="font-semibold">Service Delivery:</span> To provide access to our legal search engine and associated features.</li>
                <li><span className="font-semibold">Payment Processing:</span> To facilitate secure subscription billing via PayHere.</li>
                <li><span className="font-semibold">Customer Support:</span> To communicate with you regarding your account, respond to inquiries, and provide support.</li>
                <li><span className="font-semibold">Platform Improvement:</span> To enhance our services, based on user feedback and usage patterns.</li>
                <li><span className="font-semibold">Security and Compliance:</span> To detect and prevent fraud, unauthorized access, and ensure compliance with legal obligations.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">Information Sharing</h2>
              <p className="text-gray-600 mb-4">We respect your privacy and will not sell, trade, or transfer your personal information without your consent, except in the following cases:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li><span className="font-semibold">Service Providers:</span> We share information with trusted third-party providers for payment processing (PayHere), identity management (WSO2 Asgardeo), and other operational needs. These providers are required to protect your data in accordance with contractual and legal obligations.</li>
                <li><span className="font-semibold">Legal Obligations:</span> We may disclose your information in response to legal requests, court orders, or to comply with applicable laws.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">Data Security</h2>
              <p className="text-gray-600 mb-4">We implement industry-standard security measures, including encryption and secure authentication via WSO2 Asgardeo and PayHere, to protect your personal information from unauthorized access. However, no online transmission or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">Cookies and Tracking Technologies</h2>
              <p className="text-gray-600 mb-4">We use cookies to enhance your user experience, analyze platform usage, and tailor content. You can manage cookie preferences through your browser settings, though disabling cookies may limit certain functionalities.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">Changes to the Privacy Policy</h2>
              <p className="text-gray-600 mb-4">We may update this Privacy Policy from time to time. Any changes will be posted on this page with a revised &quot;Effective Date.&quot; Continued use of the platform after such changes constitutes acceptance of the updated policy.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">Contact Us</h2>
              <p className="text-gray-600 mb-4">If you have any questions or concerns about this Privacy Policy or the handling of your personal information, please contact us at:</p>
              <p className="text-gray-600 mb-2">Email: <a href="mailto:admin@paralegal.lk" className="text-pl_prim_color_1 underline">admin@paralegal.lk</a></p>
              <p className="text-gray-600">
                Paralegal (Pvt) Ltd<br />
                95, Chemmani Road,<br />
                Nallur,<br />
                Jaffna 40000
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Privacy;
